// i18n area 'networks' — locale el-GR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.el-GR.meta.json.
import type { enUS } from './networks'

export const elGR: typeof enUS = {
  networks: {
    common: {
      name: 'Όνομα',
      scope: 'Scope',
      operState: 'Κατάσταση',
      actions: 'Ενέργειες',
      create: 'Δημιουργία',
      close: 'Κλείσιμο',
      cancel: 'Άκυρο',
      delete: 'Διαγραφή',
      edit: 'Επεξεργασία',
      save: 'Αποθήκευση',
      editError: 'Η επεξεργασία απέτυχε',
      search: 'Αναζήτηση κατά όνομα',
      empty: 'Τίποτα εδώ ακόμη',
      saveError: 'Αδυναμία αποθήκευσης',
      loadError: 'Αδυναμία φόρτωσης — είναι προσβάσιμο το backend TVirt;',
      createError: 'Η δημιουργία απέτυχε',
      deleteError: 'Η διαγραφή απέτυχε',
      deleteConfirmTitle: 'Διαγραφή του «{name}»;',
      deleteConfirmBody: 'Η ενέργεια δεν είναι αναστρέψιμη.',
      nameHint: 'Πεζά γράμματα, ψηφία και παύλες (DNS-1123)',
      up: 'Ενεργό',
      down: 'Ανενεργό',
      unknown: 'Άγνωστο',
      usedByVMs: 'VM',
      emptyTable: 'Καμία καταχώριση — προσθέστε μία με το κουμπί +'
    },
    dialogTabs: {
      general: 'Γενικά',
      base: 'Βασικός ορισμός',
      advanced: 'Προχωρημένη διαμόρφωση',
      reserved: 'Δεσμευμένα για το TVirt εύρη',
      position: 'Θέση',
      network: 'Διαμόρφωση δικτύου',
      hosts: 'Συμμετέχοντες κόμβοι'
    },
    reservedRanges: {
      note: 'Αυτά είναι τα εύρη IP που είναι δεσμευμένα για το TVirt, το οποίο μπορεί να τα χρησιμοποιεί για να αναθέτει αυτόματα μια διεύθυνση σε VM, container κ.λπ. ΣΗΜΕΙΩΣΗ: οι IP σε αυτά τα εύρη δεν πρέπει να χρησιμοποιούνται εκτός TVirt από εξωτερικές υπηρεσίες/συσκευές.',
      from: 'Από',
      to: 'Έως'
    },
    overlay: {
      title: 'Δίκτυα επικάλυψης',
      createTitle: 'Δημιουργία δικτύου επικάλυψης',
      editTitle: 'Επεξεργασία δικτύου επικάλυψης',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — ανατίθεται αυτόματα αν μείνει κενό',
      subnet: 'Υποδίκτυο',
      subnetHint: 'Το CIDR της επικάλυψης — το IPAM παράγει αυτόματα από αυτό την εγγραφή του μητρώου του',
      mtu: 'MTU',
      weight: 'Βάρος',
      ceilMbps: 'Όριο (Mbps)',
      fairnessHint: 'Το βάρος μετρά μόνο υπό συμφόρηση: σε αδρανή ζεύξη κάθε δίκτυο μπορεί να χρησιμοποιήσει όλο το εύρος ζώνης. Το όριο όμως ισχύει πάντα.',
      contention: 'Συναγωνισμός',
      contentionTip: 'Τουλάχιστον ένας κόμβος παρατηρεί απορρίψεις ή overlimit ΜΕ ουρά στην κλάση αυτού του δικτύου: το εύρος ζώνης του uplink διεκδικείται και τα βάρη δρουν. Το πόσο και από πότε βρίσκονται στις σειρές net.shaping.* του κόμβου.',
      firewallPolicy: 'Πολιτική τείχους προστασίας',
      hosts: 'Host',
      hostsTitle: 'Συμμετέχοντες κόμβοι',
      hostsHint: 'Κάθε κόμβος δηλώνει το endpoint του στο υποκείμενο δίκτυο — ένα πεδίο επιλογής πάνω στις ΠΡΑΓΜΑΤΙΚΕΣ διευθύνσεις του κόμβου, διαβασμένες από τη διαμόρφωση δικτύου του· η προαιρετική διεύθυνση επικάλυψης πρέπει να βρίσκεται μέσα στο υποδίκτυο. Η συμμετοχή είναι ο περιορισμός placement.',
      hostNode: 'Κόμβος',
      hostUnderlay: 'IP υποκείμενου δικτύου',
      hostUnderlayPickNode: 'Επιλέξτε πρώτα τον κόμβο',
      hostAddress: 'Διεύθυνση στην επικάλυψη (προαιρετική)',
      hostAddressOutside: 'Εκτός του subnet του overlay ({cidr})',
      addHost: 'Προσθήκη κόμβου',

      // Γύρος #156 (πρότυπο διαλόγου): οι παρατηρούμενες γραμμές του διαλόγου λεπτομερειών.
      observedAt: 'Παρατηρήθηκε στις',
      attachedNics: 'Συνδεδεμένες NIC'
    },
    services: {
      title: 'Υπηρεσίες δικτύου',
      createTitle: 'Δημιουργία υπηρεσίας δικτύου',
      editTitle: 'Επεξεργασία υπηρεσίας δικτύου',
      kind: 'Τύπος',
      kindCategory: 'Υπηρεσίες',
      selectKindHint: 'Επιλέξτε τον τύπο της υπηρεσίας — ο υποκείμενος δαίμονας είναι λεπτομέρεια υλοποίησης που το TVirt διαχειρίζεται για εσάς.',
      kindLabel: {
        dhcp: 'Διακομιστής DHCP',
        ntp: 'Διακομιστής NTP',
        vpn: 'Διακομιστής VPN',
        dns: 'Διακομιστής DNS',
        gateway: 'Πύλη',
        'lb-rp': 'Εξισορροπητής φορτίου και reverse proxy',
        floatip: 'Κινητή IP'
      },
      kindDesc: {
        dhcp: 'Αναθέτει διευθύνσεις στα εξυπηρετούμενα υποδίκτυα — τα pool προκύπτουν από το υποδίκτυο, την πύλη και τα δεσμευμένα για το TVirt εύρη του δικτύου.',
        dns: 'Αυθεντικός DNS πάνω στις δηλωμένες ζώνες — οι εγγραφές προκύπτουν από το IPAM συν τις χειροκίνητές σας.',
        gateway: 'Ο κόμβος λειτουργεί ως πύλη για ένα δίκτυο — NAT (DNAT, 1:1, SNAT/masquerade) συν στατική δρομολόγηση μεταξύ των συνδεδεμένων δικτύων, αυτοθεραπευόμενο εκ σχεδιασμού.',
        'lb-rp': 'Load balancer / reverse proxy μπροστά από τις υπηρεσίες σας — L4 ή L7 listeners πάνω σε pools μελών ή στις έτοιμες παρουσίες ενός Pod, με επαναρύθμιση εν λειτουργία.',
        ntp: 'Η υπηρεσία ώρας των δικτύων — relay εξωτερικών διακομιστών upstream, ή το ρολόι του κόμβου που προσφέρεται στους client.',
        vpn: 'Ένας συγκεντρωτής VPN στον κόμβο — WireGuard ή OpenVPN, εσείς επιλέγετε: απομακρυσμένη πρόσβαση για περιαγόμενους client, ή ένα tunnel site to site μεταξύ δύο δικτύων.',
        floatip: 'Μία διεύθυνση που κάθεται σε μία μόνο υγιή παρουσία App ή Pod κάθε φορά και μετακινείται στον επόμενο υγιή στόχο όταν αυτός πέσει — failover χωρίς δαίμονες· η εξισορρόπηση μένει στον load balancer.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Η κινητή IP ζει στο επιλεγμένο δίκτυο ως ΕΠΙΠΛΕΟΝ διεύθυνση μέσα στον χώρο ονομάτων της κατέχουσας παρουσίας: χωρίς θύρες, χωρίς εξισορρόπηση, χωρίς NAT — η IP του πελάτη μένει αληθινή.',
        address: 'Κινητή IP',
        targets: 'Στόχοι',
        targetsHint: 'Με σειρά ΠΡΟΤΙΜΗΣΗΣ: ο πρώτος υγιής στόχος κρατά τη διεύθυνση. Ένα Pod σημαίνει όλες τις παρουσίες του, ανά αντίγραφο· κάθε στόχος έχει δικό του κριτήριο υγείας. Κάθε στόχος πρέπει να είναι συνδεδεμένος στο ίδιο δίκτυο.',
        targetKind: 'Στόχος',
        targetApp: 'Παρουσία App',
        targetPod: 'Pod (όλες οι παρουσίες)',
        targetRef: 'Ποιο',
        health: 'Υγεία',
        healthRunning: 'Σε εκτέλεση (κάθε container έτοιμο)',
        healthTcp: 'Σύνδεση TCP',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Θύρα',
        path: 'Διαδρομή',
        addTarget: 'Προσθήκη στόχου',
        moveUp: 'Μετακίνηση πάνω',
        moveDown: 'Μετακίνηση κάτω',
        preempt: 'Preempt',
        preemptHint: 'Απενεργοποιημένο (προεπιλογή): ένας υγιής κάτοχος κρατά τη διεύθυνση ακόμη κι αν επιστρέψει υψηλότερος στόχος — χωρίς ταλάντωση. Ενεργό: ο πρώτος υγιής στόχος την κρατά πάντα.',
        holder: 'Κάτοχος',
        noHolder: 'κανένας υγιής στόχος',
        since: 'από',
        verdicts: 'Παρατηρούμενοι στόχοι',
        healthy: 'υγιής',
        unhealthy: 'μη υγιής',
        noVerdict: 'Δεν έχει αποφασιστεί ακόμη — ο κόμβος αυθεντίας γράφει την πρώτη κρίση στο επόμενο πέρασμά του.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Αυτή η παρουσία κρατά την κινητή IP {address} της υπηρεσίας {service}'
      },
      poolSource: 'Endpoints',
      poolSourceMembers: 'Στατικά μέλη',
      poolSourcePod: 'Οι έτοιμες παρουσίες ενός Pod',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Θύρα',
      poolBackendHint: 'Τα endpoints ακολουθούν το Pod: μια παρουσία μπαίνει όταν τρέχει με κάθε container έτοιμο, φεύγει αμέσως όταν μειωθεί ή πεθάνει. Ο ενεργός έλεγχος είναι ενεργός εξ ορισμού.',
      poolBackendCount: 'οι έτοιμες παρουσίες του Pod {pod} στη θύρα {port}',
      node: 'Κόμβος',
      enabled: 'Ενεργοποιημένο',
      parked: 'Παρκαρισμένο',
      subnets: 'Υποδίκτυα',
      subnetsHint: 'Τα υποδίκτυα IPAM που εξυπηρετεί αυτή η παρουσία — τα pool προκύπτουν από το CIDR, την πύλη και τα δεσμευμένα για το TVirt εύρη',
      noSubnets: 'Κανένα υποδίκτυο IPAM — δηλώστε πρώτα ένα λογικό δίκτυο fabric (ή ένα υποδίκτυο επικάλυψης): το IPAM προκύπτει από αυτά',
      iface: 'Διεπαφή ακρόασης',
      ifaceHint: 'Η διεπαφή host στην οποία η υπηρεσία ανοίγει το socket της (π.χ. μια γέφυρα) — υποχρεωτική: μια υπηρεσία δικτύου είναι αυτόνομη, το «όλες οι διεπαφές» δεν υπάρχει πια',
      dns: 'Διακομιστές DNS',
      domain: 'Τομέας',
      detail: 'Εξυπηρετεί',
      subnetCount: '{n} υποδίκτυα',
      zones: 'Ζώνες',
      zonesHint: 'Μόνο αυθεντικός — ο δαίμονας δεν κάνει ποτέ αναδρομική επίλυση. Οι εγγραφές A προκύπτουν από τις δηλωμένες διευθύνσεις των κόμβων στα αναφερόμενα υποδίκτυα IPAM· ο διακόπτης reverse εξυπηρετεί και τις αντίστοιχες ζώνες in-addr.arpa (PTR). Μια ζώνη εξυπηρετείται από το πολύ μία παρουσία DNS σε όλο τον στόλο. Ο προαιρετικός nameserver είναι το FQDN που γράφεται στις εγγραφές NS/SOA αντί του προεπιλεγμένου ns.<zona>· αν πέφτει μέσα στη ζώνη, η εγγραφή A του προκύπτει ούτως ή άλλως από τον εξυπηρετούντα κόμβο.',
      zoneName: 'Όνομα ζώνης',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'Υποδίκτυα IPAM',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Χειροκίνητες εγγραφές',
      zoneRecordsHint: 'Μία ανά γραμμή: όνομα ΤΥΠΟΣ τιμή — τύποι A, CNAME, MX, TXT. Σε σύγκρουση ονόματος η χειροκίνητη εγγραφή υπερισχύει της προκύπτουσας.',
      addZone: 'Προσθήκη ζώνης',

      // lb-rp (θεμέλια του κύματος 3): listener πάνω σε inline pool — χωρίς engine,
      // αναδιαμορφώνεται εν λειτουργία.
      lbListeningHint: 'Η παρουσία δηλώνει ΕΝΑ δίκτυο ακρόασης και ΜΙΑ διεύθυνση — κάθε listener τη δεσμεύει στη δική του θύρα· μια δεύτερη διεύθυνση είναι μια δεύτερη υπηρεσία.',
      listeners: 'Listener',
      listenersHint: 'Κάθε listener δεσμεύει τη διεύθυνση της παρουσίας στη δική του θύρα σε λειτουργία L4 (passthrough TCP — τα byte δεν ανοίγονται ποτέ) ή L7 (HTTP) και προωθεί σε ένα από τα παρακάτω pool. Ένα ζεύγος διεύθυνσης/θύρας εξυπηρετείται από το πολύ μία παρουσία ανά κόμβο. Οι αλλαγές εφαρμόζονται εν λειτουργία — καμία επανεκκίνηση, καμία χαμένη σύνδεση.',
      listenerName: 'Όνομα',
      listenerMode: 'Λειτουργία',
      modeL7: 'L7 — reverse proxy HTTP',
      modeL4: 'L4 — passthrough TCP',
      listenerPort: 'Θύρα',
      listenerPool: 'Pool',
      addListener: 'Προσθήκη listener',
      pools: 'Pool',
      poolsHint: 'Τα backend στα οποία προσγειώνεται η κίνηση: στατικά μέλη εξισορροπημένα round-robin ή κατά το λιγότερο απασχολημένο, με προαιρετικό ενεργό health check που βγάζει από την περιστροφή τα άρρωστα μέλη.',
      poolName: 'Όνομα',
      poolAlgorithm: 'Αλγόριθμος',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Λιγότερο απασχολημένο',
      poolCheck: 'Health check',
      checkNone: 'Κανένας',
      checkTcp: 'Σύνδεση TCP',
      checkHttp: 'HTTP',
      poolCheckPath: 'Διαδρομή ανίχνευσης',
      poolInterval: 'Διάστημα (s)',
      poolMembers: 'Μέλη',
      poolMembersHint: 'Ένα ανά γραμμή: διεύθυνση:θύρα, προαιρετικά ακολουθούμενο από ένα βάρος (1-128) — π.χ. 10.0.0.21:8080 2',
      addPool: 'Προσθήκη pool',
      memberCount: '{n} μέλη',

      // ntp (γύρος ntp — επικύρωση 2026-08-03, το τελευταίο kind της οικογένειας):
      // ο τρόπος με απλά λόγια, η λίστα upstream μόνο όπου σημαίνει κάτι,
      // η σύνδεση δικτύου επαναχρησιμοποιεί τις επιγραφές της πύλης.
      // #239 (αυτόνομα netsvc): ο κοινός επεξεργαστής της λίστας των listener
      // των kind dns και ntp — οι δύο επικυρωμένες εξαιρέσεις πολλαπλών δικτύων.
      listen: {
        assignment: 'Ανάθεση',
        assignmentStatic: 'Στατική διεύθυνση',
        assignmentAuto: 'Αυτόματη (δεσμευμένα εύρη TVirt)',
        autoHint: 'Το TVirt εξάγει τη διεύθυνση από τα δεσμευμένα εύρη του λογικού δικτύου και την κρατά sticky — ποτέ δεν ξανατραβιέται σε επεξεργασία ή failover.',
        title: 'Listener',
        hint: 'Μια υπηρεσία δικτύου είναι αυτόνομη: κάθε listener δηλώνει το δίκτυό του (επικάλυψη, λογικό δίκτυο fabric ή διεπαφή) και μια διεύθυνση μέσα στο υποδίκτυό του — ένας listener ανά διεύθυνση, το wildcard δεν υπάρχει πια. Οι DNS και NTP μπορούν να ακούν σε περισσότερα δίκτυα και περισσότερες διευθύνσεις αυτών των δικτύων.',
        address: 'Διεύθυνση ακρόασης',
        add: 'Προσθήκη listener'
      },
      ntp: {
        mode: 'Τρόπος συγχρονισμού',
        modeRelay: 'Relay εξωτερικών διακομιστών',
        modeNodeClock: 'Ρολόι του κόμβου',
        modeHint: 'Το relay προσφέρει την ώρα που λαμβάνεται από τους δηλωμένους διακομιστές upstream· το ρολόι του κόμβου προσφέρει την ώρα του εξυπηρετούντος κόμβου — την οποία η συστοιχία κρατά ούτως ή άλλως συγχρονισμένη',
        servers: 'Διακομιστές upstream',
        serversHint: 'Διαχωρισμένοι με κόμμα — hostname ή διεύθυνση IP· η υπηρεσία παίρνει την ώρα από εδώ και την προσφέρει στο δίκτυο',
        port: 'Θύρα ακρόασης',
        listening: 'Σε ακρόαση σε'
      },

      vpn: {
        engine: 'Μηχανή',
        engineHint: 'Εσείς την επιλέγετε, και δεν αλλάζει πια: το WireGuard είναι μοντέρνο, γρήγορο και in-kernel· το OpenVPN είναι ο βετεράνος της συμβατότητας (TCP, εχθρικά δίκτυα)',
        engineLocked: 'Η μηχανή είναι αμετάβλητη — μια άλλη μηχανή είναι μια νέα υπηρεσία, κλειδιά και πιστοποιητικά δεν είναι μεταφέρσιμα',
        mode: 'Τρόπος',
        modeRemote: 'Απομακρυσμένη πρόσβαση',
        modeSite: 'Site to site',
        modeHint: 'Η απομακρυσμένη πρόσβαση δίνει στους περιαγόμενους client μια διεύθυνση στο tunnel· το site to site ενώνει δύο δίκτυα',
        port: 'Θύρα ακρόασης',
        protocol: 'Μεταφορά',
        protocolWireguardHint: 'Το WireGuard μιλά μόνο UDP',
        tunnelSubnet: 'Υποδίκτυο του tunnel',
        tunnelSubnetHint: 'Το δίκτυο στο οποίο ζουν οι client — καταχωρισμένο στο μητρώο IPAM, γεννιέται και πεθαίνει με αυτή την υπηρεσία',
        dnsServers: 'DNS που ωθούνται στους client',
        routes: 'Διαδρομές που ωθούνται στους client',
        routesHint: 'Δίκτυα διαχωρισμένα με κόμμα, προσβάσιμα μέσα από το tunnel· το υποδίκτυο του tunnel περιλαμβάνεται πάντα',
        peers: 'Peer',
        peersHint: 'Αφήστε κενό το δημόσιο κλειδί και το TVirt παράγει το ζεύγος — και το παραδίδει έπειτα με το προφίλ. Επικολλήστε ένα κλειδί και ο peer κρατά το δικό του.',
        clients: 'Client',
        clientsHint: 'Κάθε client λαμβάνει ένα πιστοποιητικό εκδεδομένο από την CA αυτής της υπηρεσίας. Η αφαίρεση ενός client τον ΑΝΑΚΑΛΕΙ: η CRL αναδημιουργείται αμέσως.',
        peerName: 'Όνομα',
        publicKey: 'Δημόσιο κλειδί',
        publicKeyMinted: 'Το παράγει το TVirt',
        peerAddress: 'Διεύθυνση στο tunnel',
        peerAddressHint: 'Κενό = ανατίθεται',
        allowedIps: 'Απομακρυσμένα υποδίκτυα',
        allowedIpsHint: 'Διαχωρισμένα με κόμμα, δρομολογούνται μέσα από αυτόν τον peer',
        endpoint: 'Endpoint',
        presharedKey: 'Προδιαμοιρασμένο κλειδί',
        keepalive: 'Keepalive (s)',
        addPeer: 'Προσθήκη peer',
        addClient: 'Προσθήκη client',
        auth: 'Έλεγχος ταυτότητας',
        authTls: 'Πιστοποιητικά (TLS)',
        remote: 'Απομακρυσμένο endpoint',
        remoteHint: 'host:θύρα του απομακρυσμένου άκρου — κενό σημαίνει ότι αυτή η πλευρά περιμένει',
        peerRoutes: 'Απομακρυσμένα υποδίκτυα',
        serverPublicKey: 'Δημόσιο κλειδί αυτού του διακομιστή',
        ca: 'Αρχή πιστοποίησης',
        listening: 'Σε ακρόαση σε',
        tunnel: 'Tunnel',
        peerCount: '{n} peer',
        download: 'Λήψη προφίλ',
        downloadError: 'Δεν ήταν δυνατή η εξαγωγή του προφίλ',
        lastHandshake: 'Τελευταία χειραψία',
        never: 'ποτέ',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Συνδεδεμένος',
        idle: 'Αδρανής'
      },

      // Gateway (κύμα 3 — γεννήθηκε ως nat, επικύρωση 2026-08-01/02· μετονομάστηκε
      // και επεκτάθηκε στις 2026-08-03): οι τρεις οικογένειες κανόνων NAT συν οι
      // στατικές διαδρομές πάνω σε ένα δίκτυο ακρόασης. Κάθε επικυρωμένη μορφή υποστηρίζεται.
      gateway: {
        attach: 'Τύπος δικτύου ακρόασης',
        attachOverlay: 'Δίκτυο επικάλυψης',
        attachNetwork: 'Λογικό δίκτυο fabric',
        attachInterface: 'Γυμνή διεπαφή',
        overlay: 'Δίκτυο επικάλυψης',
        network: 'Λογικό δίκτυο',
        interface: 'Όνομα διεπαφής',
        interfaceHint: 'Μια διεπαφή host που το TVirt δεν διαχειρίζεται — η διεύθυνση λαμβάνεται ως έχει',
        address: 'Διεύθυνση ακρόασης (πύλη)',
        addressHint: 'Η διεύθυνση της πύλης στην οποία δείχνουν οι client — μέσα στο υποδίκτυο του δικτύου ακρόασης',
        dnatTitle: 'Κανόνες DNAT',
        dnatHint: 'NAT προορισμού: η κίνηση που ταιριάζει ανακατευθύνεται σε μια νέα διεύθυνση (και προαιρετικά μια νέα θύρα). Οποιοδήποτε πρωτόκολλο της λίστας — οι θύρες όπου το πρωτόκολλο τις μεταφέρει.',
        snatTitle: 'Κανόνες SNAT',
        snatHint: 'NAT προέλευσης: η κίνηση που ταιριάζει βγαίνει με ξαναγραμμένη προέλευση — μια ρητή νέα διεύθυνση (και προαιρετικά μια νέα θύρα), ή masquerade στη διεύθυνση εξόδου αν μείνει κενό.',
        oneToOneTitle: 'Κανόνες NAT 1:1',
        oneToOneHint: 'Κάθε πακέτο προς την εξωτερική διεύθυνση αντιστοιχίζεται στην εσωτερική, και ο εσωτερικός host βγαίνει ως ο εξωτερικός — όλα τα πρωτόκολλα, και οι δύο κατευθύνσεις.',
        external: 'Εξωτερική διεύθυνση',
        internal: 'Εσωτερική διεύθυνση',
        addOneToOne: 'Προσθήκη κανόνα 1:1',
        family: 'Οικογένεια',
        protocol: 'Πρωτόκολλο',
        source: 'Προέλευση (διεύθυνση/υποδίκτυο)',
        destination: 'Προορισμός (διεύθυνση/υποδίκτυο)',
        invert: 'NOT',
        srcPorts: 'Θύρες προέλευσης',
        dstPorts: 'Θύρες προορ.',
        dstPortsHint: 'Θύρα ή εύρος (80, 8000-8099)',
        toAddress: 'Νέα διεύθυνση',
        toPort: 'Νέα θύρα',
        snatTo: 'Νέα προέλευση (κενή = masquerade)',
        snatToHint: 'Ρητή διεύθυνση προέλευσης· κενή = masquerade στη διεύθυνση εξόδου',
        addDnat: 'Προσθήκη κανόνα DNAT',
        addSnat: 'Προσθήκη κανόνα SNAT',
        routesTitle: 'Στατικές διαδρομές',
        routesHint: 'Ο κόμβος δρομολογεί μεταξύ των δικτύων στα οποία είναι συνδεδεμένος (το IP forwarding είναι ενεργό)· αυτές οι διαδρομές προσθέτουν προσβασιμότητα πέρα από αυτά — καθαρός kernel, η δυναμική δρομολόγηση έρχεται με επόμενο γύρο.',
        routeDestination: 'Υποδίκτυο προορισμού',
        routeGateway: 'Next hop',
        routeMetric: 'Μετρική',
        addRoute: 'Προσθήκη διαδρομής',
        listening: 'Σε ακρόαση σε',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} διαδρομές'
      },
      unknownSince: 'Άγνωστο — τελευταίο report πριν από {m} min',
      lastWord: 'Τελευταία λέξη',

      // Γύρος #156 (πρότυπο διαλόγου): οι παρατηρούμενες γραμμές και η σύνοψη
      // μόνο για ανάγνωση του μπλοκ kind στον διάλογο λεπτομερειών.
      reportObservedAt: 'Τελευταίο report',
      lastErrorRow: 'Τελευταίο σφάλμα',
      recordsCount: '{n} χειροκίνητες εγγραφές',
      phase: {
        configured: 'Διαμορφωμένο',
        running: 'Σε εκτέλεση',
        error: 'Σφάλμα'
      },
      authorityNode: 'Αρμόδιος κόμβος (ανάθεση)',
      preferredNode: 'Προτιμώμενος κόμβος',
      preferredNodeHint: 'Μια ήπια προτίμηση, ποτέ δέσμευση: στην επόμενη απόφαση τοποθέτησης η παρουσία προσγειώνεται εδώ αν το μέλος είναι επιλέξιμο — από μόνη της δεν μετακινεί τίποτα· η κίνηση είναι η «Μεταφορά αρμοδιότητας».',
      noPreference: 'Καμία προτίμηση (αυτόματη τοποθέτηση)',
      moving: 'Σε μετακίνηση',
      movingTooltip: 'Παρατηρείται εδώ ενώ η αρμοδιότητα ορίζει τον {node}: η κίνηση συγκλίνει.',
      placement: {
        title: 'Τοποθέτηση',
        loading: 'Καταμέτρηση σε εξέλιξη…',
        loadError: 'Η καταμέτρηση τοποθέτησης δεν απάντησε — δοκιμάστε ξανά αργότερα.',
        draftHint: 'Η καταμέτρηση υπολογίζεται από τη δηλωμένη σύνδεση δικτύου: θα εμφανιστεί μόλις δημιουργηθεί η υπηρεσία. Η δημιουργία απορρίπτεται αν κανένα μέλος δεν μπορεί να την εξυπηρετήσει, και η απόρριψη κατονομάζει τον μηχανισμό που άδειασε το σύνολο.',
        eligibleCount: '{n} από {m} μέλη μπορούν να εξυπηρετήσουν αυτή την παρουσία',
        recommended: 'Συνιστάται',
        eligible: 'Επιλέξιμο',
        notEligible: 'Μη επιλέξιμο',
        blockedReachability: 'το δίκτυο δεν φτάνει σε αυτό το μέλος',
        blockedRequireTag: 'μπλοκαρισμένο από απαιτούμενη ετικέτα (requireNodes)',
        blockedExcluded: 'εξαιρέθηκε από την προσομοίωση',
        preferenceUnknown: 'δεν είναι (πια) μέλος της συστοιχίας',
        preferenceIgnored: 'Η προτίμηση «{node}» δεν είναι επιλέξιμη σήμερα: {reason}. Υπερισχύει η σύσταση της καταμέτρησης — ποτέ σφάλμα, η υπηρεσία ζει αλλού.',
        emptyReachability: 'Κανένα μέλος δεν μπορεί να εξυπηρετήσει αυτή την παρουσία: το δίκτυο δεν φτάνει πουθενά — καμία επέμβαση στις ετικέτες δεν θα βοηθήσει. Καλωδιώστε τον κόμβο, ή μετακινήστε την υπηρεσία εκεί όπου υπάρχει το δίκτυο.',
        emptyRequireTag: 'Κανένα μέλος δεν μπορεί να εξυπηρετήσει αυτή την παρουσία: οι απαιτούμενες ετικέτες είναι που άδειασαν το σύνολο — αφαιρέστε την καταχώριση από το requireNodes, ή βάλτε ετικέτα σε ένα μέλος.',
        spof: 'Μοναδικό σημείο αποτυχίας',
        spofDetail: 'Ακριβώς ένα μέλος μπορεί να φιλοξενήσει την παρουσία: στην αποτυχία το failover δεν έχει πού να πάει. Μια υπηρεσία με πολλαπλούς listener μετακινείται ως ΜΟΝΑΔΑ — ο υποψήφιος πρέπει να βλέπει ΟΛΑ τα δίκτυά της: αυτό είναι το κόστος.',
        whatIf: 'Προσομοίωση απόντων μελών',
        whatIfHint: 'Το what-if της εκκένωσης: ρωτήστε ΠΡΙΝ την εκτελέσετε, μην το ανακαλύψετε στο failover.',
        survives: 'Με τα {nodes} απόντα, η υπηρεσία έχει ακόμη ένα σπίτι.',
        notSurvives: 'Η εκκένωση των {nodes} αφήνει αυτή την υπηρεσία ΕΚΤΟΣ ΛΕΙΤΟΥΡΓΙΑΣ: ο παράγωγος περιορισμός υπερισχύει της διαθεσιμότητας (R30) — ένας δαίμονας ζωντανός εκεί όπου το δίκτυο δεν φτάνει δεν εξυπηρετεί κανέναν και δεν ειδοποιεί κανέναν.',
        transfer: 'Μεταφορά αρμοδιότητας',
        transferError: 'Η μεταφορά απέτυχε',
        transferTarget: 'Μέλος προορισμού',
        transferHint: 'Προσφέρονται μόνο τα επιλέξιμα μέλη — μια προτίμηση μέσα στο έγκυρο σύνολο, ποτέ override. Καμία εργασία: το επόμενο πέρασμα των worker ΕΙΝΑΙ η κίνηση (ο παλιός κόμβος θερίζει, ο νέος αποδίδει).'
      }
    },
    fabric: {
      tabDerivation: 'Παραγωγή',
      importNetwork: 'Εισαγωγή από άλλο fabric',
      importTitle: 'Εισαγωγή λογικού δικτύου',
      importHint: 'Η εισαγωγή είναι η ρητή προσχώρηση: το δίκτυο μένει του κατόχου (ίδια ταυτότητα, ίδιο stem, ίδιο bridge tvf-<stem>) και από εδώ αντιστοιχίζεται στις θύρες/LAGG αυτού του fabric — η αντιστοίχιση ΕΙΝΑΙ ισχυρισμός ότι η παράδοση καταλήγει στον ίδιο τομέα L2 με του κατόχου.',
      importPick: 'Δίκτυο του κατόχου',
      importNone: 'Τίποτα προς εισαγωγή: τα άλλα fabric δεν έχουν δικό τους δίκτυο που αυτό το fabric να μη γνωρίζει ήδη',
      importedNetworksTitle: 'Εισαγόμενα δίκτυα',
      noImported: 'Κανένα εισαγόμενο δίκτυο',
      importedFrom: 'εισαγόμενο από {fabric}',
      importedBy: 'Εισαγόμενο από: {list}',
      importedCount: '+{n} εισαγόμενα',
      owner: 'Κάτοχος',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Αφαίρεση εισαγωγής',
      unimportConfirm: 'Να αφαιρεθεί η εισαγωγή του δικτύου {name} (κάτοχος {fabric}) από αυτό το fabric; Απορρίπτεται όσο μια θύρα ή LAGG αυτού του fabric το αντιστοιχίζει, ή ένας guest, App ή υπηρεσία εξυπηρετείται μόνο μέσω αυτού του σκέλους.',
      unimportRefused: 'Η εισαγωγή είναι ακόμη σε χρήση — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Αυτός ο κόμβος παίρνει ήδη αυτό το δίκτυο από άλλο fabric του οποίου είναι μέλος: ένας κόμβος παίρνει ένα κοινό δίκτυο από ΕΝΑ μόνο από τα σκέλη του (δύο uplink του ίδιου L2 σε bridge χωρίς STP είναι βρόχος). Αφαίρεσε την αντιστοίχιση στις θύρες ή στο LAGG ενός από τα δύο fabric.',
          otherFabricDerived: 'Το έγγραφο φέρει το μπλοκ ενός fabric προς το οποίο ο κόμβος δεν δηλώνει πλέον καλώδιο: εφάρμοσε πρώτα το σχέδιο εκείνου του fabric (προτείνει την αφαίρεση των device του), ή πάρε την κυριότητά τους με take-ownership αν το fabric δεν υπάρχει πια.'
        },
        hint: 'Το σχέδιο παραγωγής O.3: για κάθε καλωδιωμένο κόμβο η κατάσταση, το diff παράγωγο-vs-τρέχον, η ΔΗΛΩΜΕΝΗ τοπολογία bond, τα dual-stack flips και οι δομημένες απορρίψεις/προειδοποιήσεις. Μόνο ανάγνωση μέχρι το ΡΗΤΟ apply — τίποτα δεν προσγειώνεται ποτέ μόνο του σε κόμβο.',
        refresh: 'Επαναφόρτωση σχεδίου',
        empty: 'Κανένας κόμβος δεν είναι καλωδιωμένος σε αυτό το fabric (και κανένας δεν φέρει πια το μπλοκ του).',
        refusal: 'Απόρριψη',
        warning: 'Προειδοποίηση',
        generation: 'γενιά εγγράφου {n}',
        state: {
          manual: 'Χειροκίνητο',
          derived: 'Παράγωγο',
          diverged: 'Αποκλίνον'
        },
        topologyTitle: 'Δηλωμένη τοπολογία',
        members: 'μέλη',
        primary: 'πρωτεύον',
        held: 'κρατημένο σε ΕΝΑ μέλος',
        form: {
          perNetworkBond: 'Bond ανά δίκτυο',
          singleBond: 'Ενιαίο εφεδρικό bond',
          laggBond: 'Bond LACP (LAGG)',
          singlePort: 'Μονή θύρα'
        },
        colAction: 'Ενέργεια',
        colKind: 'Είδος',
        colDevice: 'Device',
        colDetail: 'Λεπτομέρεια',
        action: {
          add: 'προσθήκη',
          remove: 'αφαίρεση',
          replace: 'αντικατάσταση'
        },
        diffEmpty: 'Κανένα εκκρεμές diff — το εφαρμοσμένο έγγραφο συμπίπτει με το render.',
        diffBlocked: 'Κανένα diff: οι παραπάνω απορρίψεις μπλοκάρουν αυτόν τον κόμβο.',
        phasePlanned: 'προγραμματισμένο (βήμα 1 από 3)',
        phaseDraining: 'αποστραγγίζεται (βήμα 2 από 3)',
        probeUnobserved: 'Αισθητήρας αποστράγγισης: ποτέ δεν αναφέρθηκε — το κενό είναι ΑΓΝΩΣΤΟ (ένα retire τώρα θα απορριπτόταν).',
        probeFailed: 'Αισθητήρας αποστράγγισης: η παρατήρηση ΑΠΕΤΥΧΕ — οι γνωστές χρονοσφραγίδες μεταφέρονται, ποτέ ένα «κενό» που κανείς δεν μέτρησε.',
        probeActive: {
          one: 'Αισθητήρας: {n} εγκατεστημένη σύνδεση ακόμα στην παλιά διεύθυνση',
          other: 'Αισθητήρας: {n} εγκατεστημένες συνδέσεις ακόμα στην παλιά διεύθυνση'
        },
        probeLastActive: 'τελευταία δραστηριότητα {time}',
        probeEmpty: {
          one: 'Αισθητήρας: κενό εδώ και {n} λεπτό',
          other: 'Αισθητήρας: κενό εδώ και {n} λεπτά'
        },
        probeEmptyUnknown: 'Αισθητήρας: κενό (από πότε, άγνωστο).',
        impact: '{nics} vNIC και {apps} App σε αυτόν τον κόμβο χρησιμοποιούν αυτά τα δίκτυα: {list}',
        apply: 'Εφαρμογή σε αυτόν τον κόμβο',
        applyTitle: 'Εφαρμογή της παραγωγής — {node}',
        applyIntro: 'Η παράγωγη διαμόρφωση ξαναγράφει το έγγραφο δικτύου του {node} ({n} αλλαγές) από την ίδια πόρτα με τον επεξεργαστή host-network — συμπεριλαμβανομένων checkpoint NetworkManager και έντιμου αισθητήρα. Οι προειδοποιήσεις του σχεδίου παρακάτω ταξιδεύουν με την πράξη: διαβάστε τις πριν επιβεβαιώσετε.',
        applyError: 'Το apply απέτυχε',
        applyRefused: 'Ο κόμβος απέρριψε:',
        planMoved: 'Το fabric άλλαξε μετά από αυτή την προεπισκόπηση — ΤΙΠΟΤΑ δεν εφαρμόστηκε. Το σχέδιο επαναφορτώθηκε: κοιτάξτε ξανά και ξαναδοκιμάστε.',
        retire: 'Απόσυρση',
        retireTitle: 'Σημείο μη επιστροφής — απόσυρση του {address}',
        restore: 'Επαναφορά',
        restoreTip: 'Πίσω στο στιγμιότυπο πριν το apply (γενιά {previous}) — η αναίρεση ενός βήματος (H13)',
        restoreTitle: 'Επαναφορά του προηγούμενου εγγράφου — {node}',
        restoreIntro: 'Το έγγραφο δικτύου του {node} επιστρέφει στο στιγμιότυπο που ελήφθη πριν το τελευταίο apply (γενιά {previous}), ξαναγραμμένο ως γενιά {next} στη θέση της {current}. Ο worker το συγκλίνει όπως κάθε άλλο έγγραφο.',
        restoreRedo: 'Το έγγραφο που αντικαταστάθηκε γίνεται το νέο στιγμιότυπο: η νέα επαναφορά είναι το redo.',
        restoreClosesChain: 'Το στιγμιότυπο είναι το χειροκίνητο έγγραφο πριν την παραγωγή: η αλυσίδα κλείνει εδώ — καμία άλλη αναίρεση, ο κόμβος είναι χειροκίνητος μέχρι το επόμενο apply.',
        restoreConfirm: 'Επαναφορά',
        restoreError: 'Η επαναφορά απέτυχε',
        retireIntro: 'Αυτό αφαιρεί οριστικά το {address} ({network}) από το {point}. Μετά από αυτή την πράξη ο δρόμος πίσω είναι το ΑΝΤΙΣΤΡΟΦΟ flip — η εκ νέου δήλωση της παλιάς διεύθυνσης μέσω της ίδιας μηχανής — ποτέ μια τυφλή επαναφορά.',
        retireOld: 'Παλιά διεύθυνση (αφαιρέθηκε)',
        retireNew: 'Νέα διεύθυνση (μένει)',
        retireEmptyFact: 'Ο αισθητήρας αποστράγγισης αναφέρει τη διεύθυνση κενή: αυτή η αφαίρεση δεν κόβει καμία παρατηρημένη σύνδεση.',
        retireConfirm: 'Απόσυρση της διεύθυνσης',
        severActiveLoss: {
          one: 'Κόψιμο {n} εγκατεστημένης σύνδεσης ακόμα στην παλιά διεύθυνση — πεθαίνει με αυτή την πράξη',
          other: 'Κόψιμο {n} εγκατεστημένων συνδέσεων ακόμα στην παλιά διεύθυνση — πεθαίνουν με αυτή την πράξη'
        },
        severUnknownLoss: 'Αποδοχή του ΑΓΝΩΣΤΟΥ: ο αισθητήρας δεν παρατήρησε ποτέ αυτή τη διεύθυνση (ή η παρατήρηση αποτυγχάνει) — ζωντανές συνδέσεις μπορεί να κοπούν.'
      },
      title: 'Fabric',
      createTitle: 'Δημιουργία fabric',
      networks: 'Δίκτυα',
      switches: 'Μεταγωγείς',
      ports: 'Θύρες',
      laggs: 'LAGG',
      subnets: 'Υποδίκτυα',
      tabOverview: 'Επισκόπηση',
      tabNetworks: 'Λογικά δίκτυα',
      tabSwitches: 'Μεταγωγείς',
      overviewHint: 'Το fabric με μια ματιά: κάθε λογικό δίκτυο με MTU και υποδίκτυο (τα VLAN ζουν μόνο στις αντιστοιχίσεις ανά θύρα/ανά LAGG — το ίδιο δίκτυο μπορεί να ταξιδεύει με διαφορετικές ετικέτες σε διαφορετικές θύρες). Το fabric είναι το μητρώο μιας ΕΞΩΤΕΡΙΚΗΣ υποδομής — το TVirt παρατηρεί και δηλώνει, δεν κάνει ποτέ provisioning, και αγγίζει μόνο τις NIC που είναι καταχωρισμένες υπό τον έλεγχό του.',
      absorptionHint: 'Κάθε υποδίκτυο που δηλώνεται εδώ ΠΑΡΑΓΕΙ την εγγραφή του στο μητρώο IPAM μέσα στην ίδια πράξη εγγραφής — ζει και πεθαίνει με το δίκτυο.',
      scopeFixedHint: 'Το scope είναι σταθερό στη ρίζα του cluster: η φυσική υποδομή αφορά εξ ορισμού ολόκληρο το cluster.',
      networksHint: 'Κάθε δίκτυο φέρει ένα υποχρεωτικό MTU (προεπιλογή 1500) και ένα υποχρεωτικό υποδίκτυο· πύλη, διακομιστές DNS και στατικές διαδρομές που δηλώνονται εδώ είναι η ΜΟΝΑΔΙΚΗ ΠΗΓΗ για τις NIC των διακομιστών, τις App και τις υπηρεσίες δικτύου.',
      switchesHint: 'Το χειροκίνητο μητρώο: μια θύρα είναι αχρησιμοποίητη, αντιστοιχισμένη (κίνηση χωρίς ετικέτα και ανά ετικέτα VLAN πάνω στα λογικά δίκτυα) ή μέλος ενός LAGG — ένα μέλος δεν φέρει δικές του αντιστοιχίσεις.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Υποχρεωτικό — το IPAM παράγει αυτόματα από αυτό την εγγραφή του μητρώου του',
      nodeAddressing: 'Διευθυνσιοδότηση κόμβων',
      nodeAddressingNone: 'Καμία — χωρίς διεύθυνση ανά κόμβο',
      nodeAddressingPool: 'Pool — μία σταθερή διεύθυνση ανά εξυπηρετούμενο κόμβο',
      nodeAddressingHint: 'Με Pool η παραγωγή του fabric αναθέτει σε κάθε εξυπηρετούμενο κόμβο μια διεύθυνση από τα εύρη που είναι δεσμευμένα για το TVirt (σταθερή μετά την ανάθεση).',
      backing: 'Backing',
      gateway: 'Πύλη',
      ranges: 'Δεσμευμένα εύρη',
      dns: 'Διακομιστές DNS (διαχωρισμένοι με κόμμα)',
      dnsShort: 'DNS',
      singleSourceHint: 'Πύλη, DNS και διαδρομές που δηλώνονται εδώ είναι η μοναδική πηγή — NIC των διακομιστών, App και υπηρεσίες δικτύου αντλούν από εδώ',
      routesTitle: 'Στατικές διαδρομές',
      routeDestination: 'Προορισμός (CIDR)',
      routeVia: 'Μέσω (next hop)',
      portUsed: 'Σε χρήση',
      vlanMappings: 'Αντιστοιχίσεις VLAN',
      vlanTag: 'Ετικέτα VLAN',
      vlanNetwork: 'Λογικό δίκτυο',
      nameTaken: 'Το όνομα χρησιμοποιείται ήδη στο fabric',
      addNetwork: 'Προσθήκη δικτύου',
      editNetwork: 'Επεξεργασία δικτύου',
      deleteNetwork: 'Αφαίρεση δικτύου',
      deleteNetworkConfirm: 'Αφαίρεση του λογικού δικτύου «{name}» από το fabric; Το παραγόμενο υποδίκτυό του στο IPAM πεθαίνει μαζί του (απορρίπτεται όσο το χρησιμοποιεί μια υπηρεσία ή μια App). Οι αντιστοιχίσεις σε θύρες και LAGG που τη δείχνουν καθαρίζονται.',
      switchName: 'Μεταγωγέας',
      portName: 'Θύρα',
      positionHint: 'Φυσική θέση (προαιρετική) — το ίδιο λεξιλόγιο με την τοποθέτηση των διακομιστών· μόνο δηλωτική',
      addSwitch: 'Προσθήκη μεταγωγέα',
      editSwitch: 'Επεξεργασία μεταγωγέα',
      deleteSwitch: 'Αφαίρεση μεταγωγέα',
      deleteSwitchConfirm: 'Αφαίρεση του μεταγωγέα «{name}» με όλες τις θύρες του; Τα LAGG συρρικνώνονται αναλόγως (και πεθαίνουν κάτω από τις δύο θύρες).',
      addPort: 'Προσθήκη θύρας',
      editPort: 'Επεξεργασία θύρας',
      deletePort: 'Αφαίρεση θύρας',
      deletePortConfirm: 'Αφαίρεση της θύρας «{name}»;',
      untagged: 'Χωρίς ετικέτα',
      tagged: 'Με ετικέτα (ετικέτα:δίκτυο)',
      taggedShort: 'Με ετικέτα',
      portCabling: 'Καλωδίωση',
      portState: 'Κατάσταση',
      stateUnused: 'αχρησιμοποίητη',
      stateMapped: 'αντιστοιχισμένη',
      laggPortGuard: 'Μια θύρα που είναι μέλος ενός LAGG επεξεργάζεται από την πλευρά του LAGG',
      laggsTitle: 'LAGG',
      laggsHint: 'Ένα LAGG είναι 2+ θύρες σε LACP και μπορεί να διασχίζει μεταγωγείς (MLAG, διαφανώς)· μπαίνουν μόνο αχρησιμοποίητες θύρες, το LAGG είναι η επιφάνεια αντιστοίχισης, μια θύρα που αφαιρείται επιστρέφει αχρησιμοποίητη.',
      addLagg: 'Προσθήκη LAGG',
      editLagg: 'Επεξεργασία LAGG',
      deleteLagg: 'Αφαίρεση LAGG',
      deleteLaggConfirm: 'Αφαίρεση του LAGG «{name}»; Οι θύρες-μέλη του επιστρέφουν αχρησιμοποίητες.',
      lacpRate: 'Ρυθμός LACP',
      laggPorts: 'Θύρες-μέλη (2+)',
      laggPortsHint: 'Μπαίνουν μόνο αχρησιμοποίητες θύρες — ελευθερώστε πρώτα μια αντιστοιχισμένη θύρα',
      noNetworks: 'Κανένα λογικό δίκτυο δηλωμένο.',
      noSwitches: 'Κανένας μεταγωγέας δηλωμένος.',
      noLaggs: 'Κανένα LAGG δηλωμένο.',
      staleConflict: 'Άλλος χειριστής άλλαξε αυτό το fabric ενώ το επεξεργαζόσουν: η αποθήκευση απορρίφθηκε για να μη σβηστεί η δουλειά του. Οι αλλαγές σου είναι ακόμα εδώ, ανέπαφες. Το ενημερωμένο fabric έχει ήδη φορτωθεί ξανά: επιβεβαίωσε ξανά για να τις εφαρμόσεις από πάνω, ή ακύρωσε και δες τι άλλαξε.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Μόνο παραγόμενο: κάθε υποδίκτυο γεννιέται από ένα λογικό δίκτυο fabric ή από μια επικάλυψη — επεξεργάζεται στην πηγή του. Οι ανατεθειμένες διευθύνσεις δείχνουν ΠΟΙΟΣ τις κατέχει· τα δεσμευμένα για το TVirt εύρη είναι τα pool της αυτόματης ανάθεσης.',
      search: 'Αναζήτηση με όνομα, CIDR ή διεύθυνση',
      empty: 'Κανένα δίκτυο — δηλώστε ένα λογικό δίκτυο fabric ή ένα υποδίκτυο επικάλυψης: το IPAM προκύπτει από αυτά αυτόματα.',
      reserved: 'Δεσμευμένα για το TVirt εύρη',
      address: 'Διεύθυνση',
      origin: 'Προέλευση',
      origin_declared: 'δηλωμένη',
      origin_observed: 'παρατηρούμενη',
      holder: 'Κατέχεται από',
      noAddresses: 'Καμία γνωστή διεύθυνση σε αυτό το υποδίκτυο.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Επικάλυψη',
      editAtSource: 'Επεξεργασία στην πηγή'
    },

    // Rete > Firewall (#168): il vocabolario dei gruppi + la terna per-NIC.
    firewall: {
      title: 'Ομάδες τείχους προστασίας',
      createTitle: 'Νέα ομάδα τείχους προστασίας',
      editTitle: 'Επεξεργασία ομάδας τείχους προστασίας',
      empty: 'Καμία ομάδα τείχους προστασίας ακόμη — δημιουργήστε μία: ένα επαναχρησιμοποιήσιμο λεξιλόγιο κανόνων, που οι NIC των guest αναφέρουν με το όνομά του.',
      nameHint: 'Γράμματα, ψηφία και εσωτερικά . - _· μοναδικό μέσα στο scope του (τα συνώνυμα αλλού ξεχωρίζουν με /scope/όνομα)',
      description: 'Περιγραφή',
      descriptionHint: 'Μία γραμμή πρόθεσης, ορατή όπου επιλέγεται η ομάδα',
      enforced: 'Επιβεβλημένη στο scope',
      enforcedHint: 'Ανενεργό: καθαρό λεξιλόγιο — οι κανόνες δεσμεύουν μόνο τις NIC που αναφέρουν την ομάδα. Ενεργό: οι κανόνες δεσμεύουν κάθε NIC guest με ενεργό τείχος προστασίας κάτω από το scope της ομάδας, αναφερόμενη ή όχι.',
      enforcedChip: 'Επιβεβλημένη',
      enforcedChipHint: 'Οι κανόνες δεσμεύουν κάθε NIC guest με ενεργό τείχος προστασίας κάτω από το scope της ομάδας, αναφερόμενη ή όχι',
      enforceWarning: 'Ενεργοποιώντας την επιβολή, οι κανόνες δεσμεύουν ΚΑΘΕ NIC guest με ενεργό τείχος προστασίας κάτω από το {scope} στην επόμενη σύγκλιση, ακόμη και χωρίς ρητή αναφορά — και μέσα σε ενεργή chain το drop ενός προγόνου είναι οριστικό: τα επίπεδα από κάτω δεν το ξανανοίγουν.',
      unenforceInfo: 'Αφαιρώντας την επιβολή, οι κανόνες μένουν μόνο στις NIC που αναφέρουν την ομάδα ρητά.',
      rules: 'Κανόνες',
      tabOverview: 'Επισκόπηση',
      tabRules: 'Κανόνες',
      orderHint: 'Η σειρά των γραμμών ΕΙΝΑΙ η σειρά αξιολόγησης μέσα στην ομάδα: κερδίζει ο πρώτος κανόνας που ταιριάζει.',
      statefulHint: 'Το stateful είναι σιωπηρό: οι απαντήσεις στην επιτρεπόμενη κίνηση περνούν μόνες τους (established/related γίνονται δεκτές, invalid απορρίπτεται — τις εγχέει η μηχανή, δεν γράφονται με το χέρι).',
      noRules: 'Κανένας κανόνας — ένα λεξιλόγιο υπό κατασκευή: η αναφορά σε αυτό είναι θεμιτή και δεν παράγει τίποτα.',
      addRule: 'Προσθήκη κανόνα',
      direction: 'Κατεύθυνση',
      directionIn: 'Εισερχόμενη',
      directionOut: 'Εξερχόμενη',
      action: 'Ενέργεια',
      action_accept: 'Αποδοχή',
      action_drop: 'Απόρριψη',
      action_reject: 'Άρνηση',
      protocol: 'Πρωτόκολλο',
      protocolAny: 'Οποιοδήποτε',
      ports: 'Θύρες',
      source: 'Πηγή',
      dest: 'Προορισμός',
      comment: 'Σχόλιο',
      addressHint: 'CIDR IPv4 ή <fabric>/<λογικό δίκτυο>· κενό = οποιοδήποτε',
      moveUp: 'Μετακίνηση πάνω',
      moveDown: 'Μετακίνηση κάτω',
      nicFirewall: 'Τείχος προστασίας',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Ομάδες τείχους προστασίας',
      nicGroupsPlaceholder: 'Επιλέξτε ομάδα…',
      nicGroupsHint: 'Οι ορατές ομάδες, μαζί με εκείνες των ανώτερων scope (χρησιμοποιήσιμες προς τα κάτω, όπως οι ετικέτες)',
      nicGroupCount: { one: '{n} ομάδα τείχους προστασίας', other: '{n} ομάδες τείχους προστασίας' },
      nicOff: 'Τείχος προστασίας ανενεργό',
      pendingRestartHint: 'Οι αλλαγές του τείχους προστασίας ακολουθούν το μοντέλο αποθηκευμένο/εφαρμοσμένο: περιμένουν το επόμενο power cycle (PendingRestart). Οι ομάδες που επιβάλλουν τα ανώτερα scope εφαρμόζονται όταν το τείχος προστασίας της NIC είναι ενεργό.',
      appConvergeHint: 'Οι αλλαγές του τείχους προστασίας εφαρμόζονται στην επόμενη σύγκλιση του κοντέινερ. Οι ομάδες που επιβάλλουν τα ανώτερα scope εφαρμόζονται όταν το τείχος προστασίας είναι ενεργό.',
      enforcedAncestors: 'Επιβεβλημένες από ανώτερα scope',
      enforcedAncestorsHint: 'Αυτή η ομάδα εφαρμόζεται σε κάθε NIC κάτω από το scope της με ΕΝΕΡΓΟ τείχος προστασίας — ο διακόπτης είναι ο γενικός διακόπτης της NIC (ανενεργό = καμία chain, πρόγονοι συμπεριλαμβανομένων)· μέσα σε ενεργή chain η εξουσία του προγόνου είναι οριστική: το drop του δεν ξανανοίγει πιο κάτω.'
    }
  }
}
